import {
  questionsCacheKey,
  resultCacheKey,
  seriesCacheKey,
} from '@mentimeter/core-hooks';

interface CacheKeyArgs {
  results: Parameters<typeof getResultsCacheKey>[0];
  slideDeck: Parameters<typeof getSlideDeckCacheKey>[0];
  slides: Parameters<typeof getSlidesCacheKey>[0];
}

type CacheKey = keyof CacheKeyArgs;

export function getDashboardSWRCacheKey<Key extends CacheKey>(
  key: Key,
  args: CacheKeyArgs[Key],
): string {
  switch (key) {
    case 'slideDeck': {
      return getSlideDeckCacheKey(args as CacheKeyArgs['slideDeck']);
    }
    case 'slides': {
      return getSlidesCacheKey(args as CacheKeyArgs['slides']);
    }
    case 'results': {
      return getResultsCacheKey(args as CacheKeyArgs['results']);
    }
    default: {
      throw new Error(`Invalid cache key: ${key}`);
    }
  }
}

const DOMAIN = 'dashboard';
const SLIDE_DECK = 'slide-deck';
const SLIDE = 'slide';
const SESSION = 'session';

interface SlideDeckCacheKeyArgs {
  slideDeckPublicKey: string;
}

type SlideDeckCacheKeyFn = (args: SlideDeckCacheKeyArgs) => string;

interface SlideCacheKeyArgs {
  slideAdminKey: string;
}

const getSlideDeckCacheKey: SlideDeckCacheKeyFn = ({ slideDeckPublicKey }) => {
  // TODO: Remove the `core-hooks` cache key.
  return seriesCacheKey(slideDeckPublicKey);
  return [DOMAIN, SLIDE_DECK, slideDeckPublicKey].join('/');
};

const getSlidesCacheKey: SlideDeckCacheKeyFn = ({ slideDeckPublicKey }) => {
  // TODO: Remove the `core-hooks` cache key.
  return questionsCacheKey(slideDeckPublicKey);
  return [DOMAIN, SLIDE_DECK, slideDeckPublicKey, 'slides'].join('/');
};

interface ResultsKeyArgs extends SlideCacheKeyArgs {
  session?: number | 'current';
}

type ResultsCacheKeyFn = (args: ResultsKeyArgs) => string;

const getResultsCacheKey: ResultsCacheKeyFn = ({
  slideAdminKey,
  session = 'current',
}) => {
  // TODO: Remove the `core-hooks` cache key.
  return resultCacheKey(slideAdminKey, session);
  return [DOMAIN, SLIDE, slideAdminKey, 'results', SESSION, session].join('/');
};
